<template>
  <div class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="card"
      label-position="right"
      label-width="160px"
    >
      <el-form-item label="所属学员" prop="student_id">
        <v-select-student
          v-model="card.student_id"
          :list="studentList"
          @change="handleStudentChange"
        />
        <router-link
          v-if="card.student_id"
          :to="RouteConfig.studentDetail.to(card.student_id)"
          class="primary-color"
        >
          查看学员主页
        </router-link>
      </el-form-item>

      <!-- 课次券提示：仅当选中学员与原学员不同且课卡已绑定课次券时显示 -->
      <v-card-ticket-warning
        v-if="cardTickets.length && card.student_id !== originalStudentId"
        :tickets="cardTickets"
        message="该课卡已绑定以下课次券，修改所属学员后这些课次券将自动失效，请确认后再提交。"
      />

      <el-form-item label="适用门店">
        <v-select-store
          class="w100"
          v-model="card.store_ids"
          :multiple="true"
          :is-location-limit="true"
          placeholder="全国通用"
        />
      </el-form-item>

      <template v-if="card.store_ids.length">
        <el-form-item
          label="适用门店限制天数"
          prop="store_limit_expire_days"
        >
          <v-input-number
            class="w100"
            placeholder="请输入适用门店限制天数，超过该天数后课卡将自动恢复全国通用"
            type="unsignedSmallInt"
            v-model="card.store_limit_expire_days"
          />
        </el-form-item>

        <el-form-item
          label="适用门店失效日期"
          prop="store_limit_expire_time"
        >
          <el-date-picker
            v-model="card.store_limit_expire_time"
            :picker-options="pickerOptions"
            align="right"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="开卡后系统将根据限制天数自动计算出失效日期"
            class="date-picker"
            value-format="timestamp"
            style="width: 100%"
          />
        </el-form-item>
      </template>

      <el-form-item label="课卡类型" prop="card_charge_type_id">
        <v-cascader-card-type
          v-model="cardTypeInfo"
          :store-ids="card.store_ids"
          :is-new="isNew"
          :student-id="card.student_id"
          @change="handleCardTypeChange"
        />
      </el-form-item>

      <template v-if="cardTypeInfo.length">
        <el-form-item label="禁止预约专栏">
          <span v-if="card.is_disable_column" class="danger-color">是</span>
          <span v-else class="success-color">否</span>
        </el-form-item>

        <el-form-item
          label="有效次数"
          prop="expire_number"
        >
          <v-input-money
            v-if="card.is_number_limit"
            class="w100"
            placeholder="每次预约课程后有效次数将递减，为 0 时不可继续使用"
            v-model="card.expire_number"
          />
          <span v-else class="success-color">期限卡，无次数限制</span>
        </el-form-item>

        <el-form-item
          label="有效天数"
          prop="expire_days"
        >
          <v-input-number
            class="w100"
            placeholder="开卡后系统将根据有效天数自动计算出失效日期"
            v-model="card.expire_days"
            type="unsignedSmallInt"
          />
        </el-form-item>

        <el-form-item
          label="失效日期"
          prop="expire_time"
        >
          <el-date-picker
            v-model="card.expire_time"
            :picker-options="pickerOptions"
            align="right"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期时间"
            class="date-picker"
            value-format="timestamp"
            style="width: 100%"
          />
        </el-form-item>

      </template>

      <el-form-item label="实际付款">
        <v-input-money
          class="w100"
          v-model="card.actual_payment"
          :is-show-suffix="true"
          placeholder="请输入购买课卡的实际付款"
        />
      </el-form-item>

      <template v-if="card.actual_payment > 0">
        <el-form-item label="收款方式" prop="card_payment_mode_id">
          <v-select-card-payment-mode class="w100" v-model="card.card_payment_mode_id"/>
        </el-form-item>

        <v-image-upload
          v-model="card.receipt"
          label="收款凭证"
          prefix="card"
          placeholder="请上传转账记录截图"
          alert="微信、支付宝转账截图必须显示付款时间、金额、付款学员头像及昵称，现金收款需拍照，否则办卡申请将被驳回。"
          propName="receipt"
        />

        <v-input-you-zan-number
          v-model="card.you_zan_number"
          :card-payment-mode-id="card.card_payment_mode_id"
          @actualPaymentChange="actual_payment => card.actual_payment = card.you_zan_payment = actual_payment"
        />

        <el-form-item v-if="card.card_payment_mode_id === cardPaymentModeIds.youZan" label="有赞核销金额">
          <v-input-money
            class="w100"
            v-model="card.you_zan_payment"
            placeholder="请输入购买有赞的核销金额"
            :is-show-suffix="true"
          />
        </el-form-item>
      </template>


      <el-form-item label="付款备注" prop="payment_remark">
        <el-input v-model="card.payment_remark" placeholder="请输入付款备注"/>
      </el-form-item>
      <v-multi-file-upload
        v-model="card.remark_files"
        label="备注文件"
        prefix="card"
      />

      <el-form-item label="可用日期">
        <el-checkbox v-model="v.checked" v-for="v in weeks" :key="v.value">{{ v.label }}</el-checkbox>
      </el-form-item>

      <el-form-item
        label="办卡日期"
        prop="register_time"
      >
        <el-date-picker
          v-model="card.register_time"
          :picker-options="pickerOptionsBetweenSystemStartAndToday"
          align="right"
          type="date"
          placeholder="请选择办卡日期，默认为当前日期"
          class="date-picker"
          value-format="timestamp"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="自动开卡日期" prop="start_time_auto">
        <el-date-picker
          v-model="card.start_time_auto"
          :picker-options="pickerOptionsOfAfterToday"
          align="right"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          placeholder="请选择自动开卡日期时间，默认不自动开卡"
          class="date-picker"
          value-format="timestamp"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="所补差价" prop="update_payment">
        <v-input-money
          class="w100"
          v-model="card.update_payment"
          :is-show-suffix="true"
          placeholder="请输入此次修改所补的差价，退款填写为负数即可"
          type="int"
        />
      </el-form-item>
      <el-form-item v-if="+card.update_payment !== 0" label="补差价方式" prop="update_payment_mode">
        <v-select-card-payment-mode class="w100" v-model="card.update_payment_mode"/>
      </el-form-item>
      <el-form-item v-if="!isAdministrator" label="修改原因" prop="update_remark">
        <el-input
          v-model="card.update_remark"
          placeholder="请输入修改课卡的原因"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item>
        <router-link v-if="card.card_del_apply_id" class="button-margin" :to="RouteConfig.cardDeleteApplyDetail.to(card.card_del_apply_id)">
          <el-button type="primary">退卡申请审核中，点击查看</el-button>
        </router-link>
        <router-link v-else-if="card.card_update_apply_id" class="button-margin" :to="RouteConfig.cardUpdateApplyDetail.to(card.card_update_apply_id)">
          <el-button type="primary">课卡修改审核中，点击查看</el-button>
        </router-link>
        <el-button v-else-if="card.is_reviewing" class="button-margin" :disabled="true" type="primary">修改申请审核中</el-button>
        <el-button v-else class="button-margin" :loading="isSaving" type="primary" @click="handleSubmit">
          {{ isAdministrator ? '保存' : '申请' }}修改
        </el-button>
        <el-button @click="RouteConfig.cardList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import cardPaymentModeIds from '@/enums/cardPaymentModeIds';
import handleCardTypeChange from '@/utils/handleCardTypeChange';
import weeks from "@/enums/weeks";
import { pickerOptionsBetweenSystemStartAndToday, pickerOptionsOfAfterToday } from '@/utils/formats';
import { toCent, toMillisecond, toSecond, toYuan } from "@/filters";
import { show, update } from '@/api/card';
import { checkIsNew } from '@/api/student';
import { store } from '@/api/card-update-apply';

export default {
  name: RouteConfig.cardEdit.name,
  data: () => ({
    RouteConfig,
    weeks: JSON.parse(JSON.stringify(weeks)),
    isSearching: false,
    isSaving: false,
    cardTypeInfo: [],
    isNew: false,
    originalStudentId: 0,
    cardPaymentModeIds,
    pickerOptionsBetweenSystemStartAndToday,
    pickerOptionsOfAfterToday,
    card: {
      student_id: '',
      store_ids: [],
      is_generic: 0,
      card_type_id: 0,
      card_type_name: '',
      card_name: '',
      card_charge_type_id: '',
      is_number_limit: 0,
      expire_number: '',
      expire_days: '',
      expire_time: '',
      store_limit_expire_days: '',
      store_limit_expire_time: '',
      card_payment_mode_id: '',
      you_zan_number: '',
      actual_payment: '',
      you_zan_payment: '',
      payment_remark: '',
      remark_files: [],
      receipt: '',
      register_time: '',
      start_time: '',
      start_time_auto: '',
      update_remark: '',
      update_payment: '',
      is_reviewing: 0,
      card_del_apply_id: 0,
      card_update_apply_id: 0,
      disabled_weeks: [],
      update_payment_mode: 0,
      is_disable_column: 0,
    },
    cardTickets: [],
    studentList: [{
      id: 0,
      student_name: '',
      nickname: '',
      phone: '',
      card_number: '',
    }],
    rules: {
      student_id: [{ required: true, message: '请选择所属学员', trigger: 'change' }],
      card_payment_mode_id: [{ required: true, message: '请选择课卡付款方式', trigger: 'change' }],
      card_charge_type_id: [{ required: true, message: '请选择课卡类型', trigger: 'change' }],
      update_payment_mode: [{ required: true, message: '请选择补差价付款方式', trigger: 'change' }],
      you_zan_number: [{ required: true, message: '请输入有赞券码', trigger: 'change' }],
      actual_payment: [{ required: true, message: '请输入实付金额', trigger: 'change' }],
      update_remark: [{ required: true, message: '请输入修改课卡的原因', trigger: 'change' }],
      receipt: [{ required: true, message: '请上传付款凭证图片', trigger: 'change' }],
    },
    pickerOptions: {
      disabledDate: (time) => time.getTime() < 0,
    },
  }),
  computed: {
    isAdministrator() {
      return this.$store.getters.isAdministrator;
    },
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async handleStudentChange(student) {
      const { isError, data } = await checkIsNew(student.id);
      this.isNew = !isError && data ? !!data.is_new : false;
    },
    handleCardTypeChange(cardTypeInfo) {
      handleCardTypeChange(cardTypeInfo, this.card);
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const card = { ...this.card };
        const { weeks } = this;
        card.card_id = this.id;
        card.register_time = toSecond(card.register_time);
        card.start_time_auto = toSecond(card.start_time_auto);
        card.expire_time = toSecond(card.expire_time);
        card.store_limit_expire_time = toSecond(card.store_limit_expire_time);
        card.expire_number = toCent(card.expire_number);
        card.actual_payment = toCent(card.actual_payment);
        card.you_zan_payment = toCent(card.you_zan_payment);
        card.update_payment = toCent(card.update_payment);
        card.disabled_weeks = [];
        for (let i = 0; i < weeks.length; i++) {
          if (!weeks[i].checked) card.disabled_weeks.push(weeks[i].value);
        }

        this.isSaving = true;
        const { isError } = this.isAdministrator
          ? await update(this.id, card)
          : await store(card);
        this.isSaving = false;

        if (!isError) this.isAdministrator ? RouteConfig.cardList.back() : RouteConfig.cardUpdateApplyList.push();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      data.update_remark = '';
      data.register_time = toMillisecond(data.register_time) || '';
      data.start_time_auto = toMillisecond(data.start_time_auto) || '';
      data.expire_time = toMillisecond(data.expire_time) || '';
      data.store_limit_expire_time = toMillisecond(data.store_limit_expire_time) || '';
      data.expire_number = toYuan(data.expire_number);
      data.actual_payment = toYuan(data.actual_payment);
      data.you_zan_payment = toYuan(data.you_zan_payment);

      const { card } = this;
      const updateCardInfo = {};
      Object.keys(data).forEach(key => {
        if (key in card) updateCardInfo[key] = data[key];
      });
      Object.assign(card, updateCardInfo);

      if (data && Array.isArray(data.disabled_weeks) && data.disabled_weeks.length) {
        const { weeks } = this;
        for (let i = 0; i < weeks.length; i++) {
          weeks[i].checked = !data.disabled_weeks.includes(weeks[i].value);
        }
      }

      Object.assign(this, {
        isNew: !!data.is_new,
        cardTypeInfo: data.card_type_info || [],
        cardTickets: data.card_tickets || [],
        originalStudentId: data.student_id || 0,
        studentList: [{
          id: data.student_id,
          student_name: data.student_name,
          nickname: data.nickname,
          selfie: data.selfie,
          phone: data.phone,
          card_number: data.card_number,
        }],
      });
    },
  },
};
</script>

<style scoped>
</style>
